import React, { FC, ReactNode } from "react";
import cn from "classnames";
import { getImageUrl } from "src/utils/getImageUrl";
import { Avatar } from "src/components/Avatar";
import { Sizes } from "src/@types/sizes";
import { IMessage } from "src/@types/message";
// import { AttachedFIleLabel } from "./AttachedFIleLabel";
import { formatTime } from "./utils/formatTime";

interface Props extends Omit<IMessage, "id"> {
  children: ReactNode;
}

export const Message: FC<Props> = ({ children, sent_at, user, is_host }) => {
  const formattedSentDate = formatTime(new Date(sent_at));

  return (
    <div
      className={cn("flex flex-col gap-2.5", {
        "text-right": is_host,
      })}
    >
      <div
        className={cn("flex gap-3 items-end md:max-w-3/5 w-full", {
          "flex-row-reverse ml-auto": is_host,
        })}
      >
          <Avatar
            sizeVariant={Sizes.XS}
            avatarUrl={getImageUrl(user.avatarUrl)}
            title={user.first_name}
          />

        <div
          className={cn(
            "flex flex-col gap-2 px-4 py-2 border border-black-base/20 rounded-20 overflow-auto",
            { "bg-blue-dark/10": is_host }
          )}
        >
          <h4 className="text-purple-base">{user.first_name}</h4>

          <pre className="text-start break-words">
            <p>{children}</p>
          </pre>

          {/* {file && <AttachedFIleLabel file={file} />} */}
        </div>
      </div>

      <time className="text-sm" dateTime={formattedSentDate}>
        {formattedSentDate}
      </time>
    </div>
  );
};
